import React, { Component } from 'react';

class ReminderModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
    };
    this.submitNewData = this.submitNewData.bind(this);
    this.setOpenModal = this.setOpenModal.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
    this.handleError = this.handleError.bind(this);
  }

  setOpenModal(isOpen) {
    this.setState({
      openModal: isOpen
    });
  }

  submitNewData(params) {
    $.ajax(this.getAjaxObject(params))
    .done(this.handleSuccess)
    .fail(this.handleError)
    .always(() => this.props.refreshList())
    this.setOpenModal(false);
  }

  parseError(errors) {
    if ('string' === typeof errors) {
      return errors;
    }
    return Object.keys(errors).map(function(fieldKey) {
        const foundError = errors[fieldKey];
        if (typeof foundError === 'string') {
          return foundError;
        }
        if (Array.isArray(foundError)){
          return foundError.join(', ')
        }
        console.log('Parsing error problem', foundError);
        return '';
      }).join('. ');
  }

  handleError(error) {
    const defaultErrorMessage = this.props.t('account.dashboard_remind_me_saving_failed', 'Something went wrong, please reload later.');

    let errorMessage = this.parseError(error.responseJSON.errors);

    toastr.error(errorMessage ? errorMessage : defaultErrorMessage);
  }

  render() {return <div></div>}
}

export default ReminderModal;


// WEBPACK FOOTER //
// ./src/Account/RemindMe/ReminderModal.js